import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=c5582aec"
import script from "./SimpleTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports